/*
 * File: AppointmentsTotals.js
 * Project: mp-mobile-app
 *
 * Created by jeddumire on 09/25/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Component to display total counts of appointments by status, takes an array of appointments
 * where each appointment has a string status property
 */
import React from "react";
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

const styles = theme => ({
  root: {
    margin: `${theme.spacing(1)}px ${theme.spacing(2.5)}px`,
    marginBottom: theme.spacing(-2)
  },
  missed: {
    color: theme.palette.common.missed
  },
  cancelled: {
    color: theme.palette.common.cancelled
  },
  reschedule: {
    color: theme.palette.common.rescheduled
  }
});

const AppointmentsTotals = ({ apptList, classes }) => {
  const totalCount = apptList.length;
  const missedCount = apptList.filter(appt => appt.status === "Missed").length;
  const cancelledCount = apptList.filter(appt => appt.status === "Cancelled")
    .length;
  const rescheduleCount = apptList.filter(
    appt => appt.status === "To Reschedule"
  ).length;

  return (
    <div className={classes.root}>
      <Typography>
        <b>Total Appointments:</b> {totalCount}
      </Typography>
      <Typography className={classes.missed}>
        <b>Missed:</b> {missedCount}
      </Typography>
      <Typography className={classes.cancelled}>
        <b>Cancelled:</b> {cancelledCount}
      </Typography>
      <Typography className={classes.reschedule}>
        <b>To Reschedule:</b> {rescheduleCount}
      </Typography>
    </div>
  );
};

AppointmentsTotals.propTypes = {
  apptList: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AppointmentsTotals);
